const documents = {

  'Persona fisica': {
    // LISTA DOCS
    '2050D08': {
      'name': 'Carta d`identità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08'
    },
    '2050D09': {
      'name': 'Codice Fiscale',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D09'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D16': {
      'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16'
    },
    '2050D17': {
      'name': 'Fattura con indicazione dello sconto praticato',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D17'
    },
    '2050D18': {
      'name': 'Bonifico Parlante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D18'
    },
    '2050D19': {
      'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
    '2050D20': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D20'
    },
    '2050D21': {
      'name': 'Delega all`invio del Modello all`Agenzia delle Entrate tra Cedente e KPMG',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D21'
    },
    '2050D22': {
      'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D22'
    }

  },

  'Partita IVA': {
    // LISTA DOCS
    '2050D10': {
      'name': 'Visura Camerale Cedente',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D16': {
      'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16'
    },
    '2050D17': {
      'name': 'Fattura con indicazione dello sconto praticato',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D17'
    },
    '2050D18': {
      'name': 'Bonifico Parlante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D18'
    },
    '2050D19': {
      'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
    '2050D20': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D20'
    },
    '2050D21': {
      'name': 'Delega all`invio del Modello all`Agenzia delle Entrate tra Cedente e KPMG',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D21'
    },
    '2050D22': {
      'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D22'
    }
  },

  'Amministratore di condominio': {
    '2050D10': {
      'name': 'Visura Camerale Cedente',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D16': {
      'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16'
    },
    '2050D17': {
      'name': 'Fattura con indicazione dello sconto praticato',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D17'
    },
    '2050D18': {
      'name': 'Bonifico Parlante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D18'
    },
    '2050D19': {
      'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
    '2050D20': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D20'
    },
    '2050D22': {
      'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D22'
    }
  }

}

export default documents



// WEBPACK FOOTER //
// ./src/components/documents/documents.js